import type Ajv from "ajv";
import { customFormatValidator } from "./customFormatValidator";

export function registerCustomValidators(ajv: Ajv): Ajv {
  Object.entries(customFormatValidator).forEach(([format, validator]) => ajv.addFormat(format, validator));
  return ajv;
}
